<template>
  <div class="paperwork-container">
    <QuestionnaireMenu class="menu" :logo="logoUrl" :languages="languageOptions"></QuestionnaireMenu>
    <div class="banner">
      <img :src="bannerUrl" alt="">
    </div>
    <questionnaire-message class="message" :messages="messages"></questionnaire-message>
    <div class="title">{{ $t('questionnaire.label.thanksLabel') }}</div>
    <template v-if="!isPc && showWeChatSpread && recruitmentUrl">
      <div class="follow-wehchat-container" @click="toFollowWeChat">
        <div class="follow-wehchat-title">
          <span>{{ $t('questionnaire.label.followWeChat') }}</span>
        </div>
        <p>{{ $t('questionnaire.label.followWeChatDesc') }}</p>
        <div class="follow-wehchat-tip-block">
          <span>{{ $t('questionnaire.label.toWeChat') }}</span>
        </div>
      </div>
    </template>
    <div class="content-container">
      <div class="subtitle">{{ finishContent }}</div>
      <div class="button-container">
        <div v-if="isCandidate" @click="handelViewJobs" class="btn view-jobs" >{{ $t('questionnaire.btn.viewJobs') }}</div>
        <span class="more-info">{{ $t('questionnaire.label.moreInformation') }}</span>
        <ul>
          <li v-if="isCandidate">
            <div class="btn view-resume" @click="handelViewResume">{{ $t('questionnaire.btn.viewResume') }}</div>
          </li>
          <li v-if="isCandidate">
            <div class="btn view-applicant" @click="handelApplicant">{{ $t('questionnaire.btn.viewApplicant') }}</div>
          </li>
          <li v-if="!isCandidate">
            <div class="btn view-dashboard" @click="handelHMDashboard">{{ $t('questionnaire.btn.viewHMDashboard') }}</div>
          </li>
        </ul>
        <template v-if="isPc && showWeChatSpread && qrcodeUrl">
          <div class="qrcode-title">{{ $t('questionnaire.label.scanToFollowWeChat') }}</div>
          <div class="qrcode-content">
            <img class="qrcode-body" :src="qrcodeUrl">
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import QuestionnaireMenu from '@/components/questionnaire/form/Menu'
import QuestionnaireMessage from '@/components/questionnaire/form/Message'
import { questionnaireMixin } from '@/components/questionnaire/form/mixin.js'
import { WECHAT_SPREAD_QUESTIONNAIRE_LIST } from '@/constant/questionnaire'
import { mapGetters, mapActions } from 'vuex'
import { deviceType } from '@/utils/common'
import _ from 'lodash'

export default {
  mixins: [questionnaireMixin],
  components: {
    QuestionnaireMenu, QuestionnaireMessage
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  data () {
    return {
      bannerUrl: '',
      userName: '',
      qrcodeUrl: '',
      recruitmentUrl: ''
    }
  },
  computed: {
    isCandidate () {
      return this.$parent.isCandidate
    },
    isPc () {
      return deviceType.isPc
    },
    companyId () {
      return this.$parent.invitationInfo.company.id
    },
    questionnaireType () {
      return this.$parent.invitationInfo.type
    },
    finishContent () {
      const questionnaireLabel = _.toLower(this.getQuestionnaireLabelByType(this.questionnaireType))
      return this.$t('questionnaire.label.finishContent', { questionnaire: questionnaireLabel })
    },
    pageTitle () {
      return this.getQuestionnaireLabelByType(this.questionnaireType)
    },
    showWeChatSpread () {
      if (WECHAT_SPREAD_QUESTIONNAIRE_LIST.includes(this.questionnaireType)) {
        return true
      }
      return false
    }

  },
  created () {
    this.bannerUrl = this.$parent.headerImage
    this.userName = this.$parent.userName
    if (this.showWeChatSpread) {
      this.initWechatSpreadSetting()
    }
  },
  methods: {
    ...mapActions('questionnaire', ['getQuestionnaireWeChatSpread']),
    ...mapGetters('account', ['getCurrentAccount']),
    async initWechatSpreadSetting () {
      const resp = await this.getQuestionnaireWeChatSpread(this.invitationId)
      if (resp) {
        this.qrcodeUrl = resp.qrcode_url
        this.recruitmentUrl = resp.recruitment_url
      }
    },
    goToHomePage () {
      this.$router.push(this.$parent.getQuestionnaireHomePath())
    },
    handelViewResume () {
      this.$router.push({ path: '/recruiting/personal/profile', query: { company_id: this.companyId } })
    },
    handelApplicant () {
      if (this.isPc) {
        this.$router.push({ path: '/recruiting/personal/home', query: { company_id: this.companyId } })
      } else {
        this.$router.push({ path: '/recruiting/personal/applications/completed', query: { company_id: this.companyId } })
      }
    },
    handelViewJobs () {
      if (this.$parent.invitationInfo?.company?.id) {
        if (this.isPc) {
          this.$router.push(`/recruiting/company/${this.companyId}/job-list`)
        } else {
          this.$router.push(`/mobile-web-more-jobs/${this.companyId}`)
        }
      }
    },
    handelHMDashboard () {
      this.$router.push('/v-admin/hm')
    },
    toFollowWeChat () {
      if (this.recruitmentUrl) {
        window.location.href = this.recruitmentUrl
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
.paperwork-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .banner {
      img {
        background-size: cover;
        width: 100%;
        height: auto;
      }
  }
  .message {
    position: fixed;
    top: 50px;
  }
  .title {
    font-weight: bolder;
    margin-top: 2rem;
    margin-bottom: 1.2rem;
    text-align: center;
    font-size: 24px;
  }
  .subtitle {
    color: gray;
  }
  .divider {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2.5rem;
    float: none;
  }
  .empty-div {
    height: 50px;
  }
  .step-zero-div {
    width: 75%;
    color: gray;

    li {
      margin: 2rem 0;
      list-style-type: disc;
      font-size: smaller !important;
    }
  }
  .next-button {
    width: 100%;
    margin: 4rem 2.5rem 4rem 0;
    padding-bottom: 100px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .follow-wehchat-container {
    border: 2px solid;
    box-shadow: 2px 4px, 5px 9px #cbbcb2, 3px 11px, 7px 7px, 7px 11px;
    padding: 18px;
    position: relative;
    margin: 20px 50px 20px 40px;

    .follow-wehchat-title {
      position: absolute;
      top: -9px;
      right: 0;
      left: 0;
      text-align: center;

      > span {
        border: 3px solid;
        background: #cbbcb2;
        padding: 3px 5px;
      }
    }

    &> p {
      padding: 10px 0;
    }

    .follow-wehchat-tip-block {
      text-align: right;

      > span {
        background: black;
        color: #FFF;
        padding: 5px;
        font-size: 14px;
      }
    }
  }

  .content-container {
    text-align: left;
    padding: 20px 40px;
    min-width: 375px;

    > div {
      font-size: 16px;
    }

    .button-container {
      margin: 0;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .btn {
        padding: 0;
        color: #0096cc;
        text-decoration: underline;
      }

      .more-info {
        color: #000000;
        font-weight: 600;
      }

      > ul {
        list-style-type: disc;
        padding: 10px 0 0 20px;
      }

      .view-jobs {
        padding: 10px 0;
        margin-bottom: 15px;
      }

      .qrcode-title {
        font-size: 16px;
        color: gray;
        margin-top: 30px;
      }

      .qrcode-content {
        .qrcode-body {
          width: 120px;
          height: 120px;
        }
      }
    }
  }
}
/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
  .next-button {
    width: 40% !important;
  }
  .steps-component {
    margin-bottom: 100px !important;
  }
  .step-zero-div {
    width: 40% !important;
    li {
      list-style-type: disc;
      margin-top: 30px !important;
      font-size: smaller !important;
    }
  }

  .paperwork-container {
    .content-container {
      .button-container {
        align-items: center;
      }
    }
  }

  .subtitle {
    text-align: center;
  }
}
</style>
